/**
 * @Description 机会点
 */

import { isArray } from '@lhb/func';
import { v4 } from 'uuid';
import { useMethods } from '@lhb/hook';
import { Typography } from 'antd';
import { FC, useEffect, useMemo, useRef } from 'react';
import { targetChancepoint, targetLegendIcon, targetMallChancepoint } from '../../../ts-config';
import cs from 'classnames';
import styles from '../index.module.less';
import ReactDOM from 'react-dom';
import IconFont from '@/common/components/IconFont';
import { mapContainer } from '..';
const targetKeys = [
  ...targetChancepoint,
  ...targetMallChancepoint,
];
const { Text } = Typography;

const ChancepointCard: FC<any> = ({
  itemData,
  markerRef,
  chancepointAlias,
}) => {
  const addressStr = useMemo(() => {
    const { columns } = itemData;
    let targetVal = columns?.find((columnItem: any) => columnItem.identification === 'basicAddress')?.textValue;
    if (targetVal) {
      targetVal = JSON.parse(targetVal);
      return targetVal?.address;
    }
    return '';
  }, [itemData]);
  const methods = useMethods({
    handleClose() {
      markerRef?.setContent('<div></div>');
    }
  });
  return <div className={styles.chancepointCardCon}>
    <img
      className={styles.img}
      src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_map_chancePoint.png`}/>
    <div className={cs('c-222 fs-16 font-weight-500', styles.chancepointHead)}>
      {chancepointAlias}
      <div className={styles.close} onClick={() => methods.handleClose()}>
        <IconFont iconHref='iconic-closexhdpi' className='c-666 fs-12' />
      </div>
    </div>
    <div className={cs('mt-12', styles.nameStyle)}>
      {itemData?.name}
    </div>
    <div className='mt-8'>
      {itemData?.statusName}
    </div>
    <div className={cs('mt-10', styles.chancepointAddressCon)}>
      <div>
        <IconFont iconHref='iconic_map_white_one' className='c-ddd fs-12'/>
      </div>
      <Text
        style={{ width: 250 }}
        ellipsis={{ tooltip: addressStr }}>
        <span className='c-666 fs-12 pl-4'>
          {addressStr}
        </span>
      </Text>
      {/* <div className='pl-4'>{addressStr}</div> */}
    </div>
  </div>;
};
const Chancepoint: FC<any> = ({
  mapIns,
  legendData,
  data,
  chancepointAlias,
  contentMarkerRef,
  onClickMarker = () => {}
}) => {
  const groupMarkersRef: any = useRef();
  // const cadrMarkerRef: any = useRef();
  const targetIconImg = useMemo(() => {
    const target = legendData?.find((item: any) => targetKeys.includes(item.key));
    return targetLegendIcon[target?.key] || '';
  }, [legendData]);

  useEffect(() => {
    if (isArray(data) && data.length) {
      methods.createChancepointMarker();
    } else {
      groupMarkersRef.current?.forEach((item: any) => {
        mapIns.remove(item);
      });
      contentMarkerRef.current && mapIns.remove(contentMarkerRef.current);
    }
    return () => {
      groupMarkersRef.current?.forEach((item: any) => {
        mapIns && mapIns.remove(item);
      });
      contentMarkerRef.current && mapIns && mapIns.remove(contentMarkerRef.current);
    };
  }, [data]);
  const methods = useMethods({
    createChancepointMarker: () => {
      const markers: any[] = [];
      data.forEach((item: any) => {
        const markerItem = methods.addItemMarker(item);
        markerItem && (markers.push(markerItem));
      });
      groupMarkersRef.current = markers;
    },
    addItemMarker: (item) => {
      const uid:any = v4();
      const { lng, lat } = item;
      const marker = new window.AMap.Marker({
        position: new window.AMap.LngLat(+lng, +lat),
        anchor: 'center',
        offset: [0, -13],
      });
      mapIns.add(marker); // 先添加到地图上
      marker.setContent(`<div id="${uid}"></div>`);
      ReactDOM.render(<div
        className={styles.chancepointMarkerCon}
        onClick={() => methods.onClickChancepointMarker(item)}
      >
        <img
          src={targetIconImg}
          width='100%'
          height='100%'
        />
      </div>, document.getElementById(uid));
      return marker;
    },
    onClickChancepointMarker: (item) => {
      const dom = document.querySelector(`.${mapContainer}`);
      var pixel = mapIns.lngLatToContainer([item?.lng, item?.lat]);
      const { x, y } = pixel;
      const offset = [0, 0];
      let topBottom = 'top';
      let leftRight = 'center';
      if (y < 200) {
        topBottom = 'top';
      } else if ((dom?.clientHeight || 0) - y < 200) {
        topBottom = 'bottom';
        offset[1] = -24;
      }
      if (x < 200) {
        leftRight = 'left';
      } else if ((dom?.clientWidth || 0) - x < 200) {
        leftRight = 'right';
        offset[0] = -12;
      }
      contentMarkerRef.current && mapIns.remove(contentMarkerRef.current);
      const uid:any = v4();
      const { lng, lat } = item;
      const marker = new window.AMap.Marker({
        position: new window.AMap.LngLat(+lng, +lat),
        // anchor: 'top-center',
        anchor: `${topBottom}-${leftRight}`,
        offset,
        zIndex: 70 // 比其他覆盖物的层级高
      });
      mapIns.add(marker); // 先添加到地图上
      marker.setContent(`<div id="${uid}"></div>`);
      contentMarkerRef.current = marker;
      onClickMarker?.();
      ReactDOM.render(<ChancepointCard
        itemData={item}
        markerRef={contentMarkerRef.current}
        chancepointAlias={chancepointAlias}
      />, document.getElementById(uid));
    }
  });
  return (
    <></>
  );
};

export default Chancepoint;
